import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function ThumbView({ thumb, onSelect }) {
    const Image = ComponentRegistry.get("Image");

    return (
      <li className="gallery-item">
        <Image src={thumb} onClick={onSelect} />
      </li>
    );
}

ThumbView.propTypes = {
    thumb: PropTypes.string,
    onSelect: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ImageGallery/Views/ThumbView.jsx